import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-gray-900 text-white py-12 mt-20">
    <div className="container px-4 mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="mb-6 md:mb-0">
          <h2 className="text-xl font-bold">Openstudio</h2>
          <p className="text-gray-400 mt-2">Oživte prázdné prostory s Openstudio</p>
        </div>
        <div className="flex flex-col md:flex-row gap-8">
          <div>
            <h3 className="text-lg font-medium mb-2">Služby</h3>
            <ul className="space-y-2">
              <li><Link to="#" className="text-gray-400 hover:text-white">Virtuální zařízení</Link></li>
              <li><Link to="#" className="text-gray-400 hover:text-white">Interiérový design</Link></li>
              <li><Link to="#" className="text-gray-400 hover:text-white">Realitní služby</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-medium mb-2">Společnost</h3>
            <ul className="space-y-2">
              <li><Link to="/kontakt" className="text-gray-400 hover:text-white">Kontakt</Link></li>
              <li><Link to="/ochrana-osobnich-udaju" className="text-gray-400 hover:text-white">Ochrana osobních údajů</Link></li>
              <li><Link to="/obchodni-podminky" className="text-gray-400 hover:text-white">Všeobecné obchodní podmínky</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-800 mt-12 pt-6 text-center">
        <p className="text-gray-400">© {new Date().getFullYear()} Openstudio. Všechna práva vyhrazena.</p>
      </div>
    </div>
  </footer>
); 